import React, { Component } from "react";
import PropTypes from "prop-types";
import { get } from "lodash";
import produce from "immer";
import StoryCard from "../shared/story-card";
import Breadcrumb from "../shared/breadcrumbs";
import styles from "../text-story-page/styles.m.css";
import PhotoAlbum from "../../../../rows/photo-album";
import StoryMidPromotion from "../../storyMidContent";
import stylesPA from "./styles.m.css";
import { VikatanResponsiveContainer } from "../../../../rows/ad-free";

class PhotoAlbumStory extends Component {
  constructor() {
    super();
    this.handleSlideChange = this.handleSlideChange.bind(this);
  }

  handleSlideChange(index) {
    if (this.firstPhotoAlbumElement) {
      const imageStoryElements = this.firstPhotoAlbumElement["story-elements"];
      const currentImageElement = imageStoryElements[index];
      const completeStorySlugArray = this.props.story.slug.split("/");
      const storySlug = completeStorySlugArray.splice(-1);
      const combinedSlug = `/${completeStorySlugArray.join("/")}/__${currentImageElement.id.replace(
        /-/g,
        ""
      )}__${storySlug}`;
      window.history.replaceState({}, "", combinedSlug);
      this.props.fireVirtualPageView();
    }
  }

  render() {
    const renderFooter = get(this.props, ["renderFooter"], () => null);
    const renderSidebar = get(this.props, ["renderSidebar"], () => null);
    const renderHeaderCard = get(this.props, ["renderHeaderCard"], () => null);
    const storyHeadline = get(this.props, ["story", "subheadline"], () => null);
    const renderSocialMedia = get(this.props, ["renderSocialMedia"], () => null);

    const firstPhotoAlbumElement = this.props.story.cards
      .reduce((acc, currEle) => {
        acc = acc.concat(currEle["story-elements"]);
        return acc;
      }, [])
      .find(({ subtype }) => subtype === "image-gallery");

    this.firstPhotoAlbumElement = firstPhotoAlbumElement;

    const renderHeaderPhotoAlbum = () => {
      if (!firstPhotoAlbumElement) {
        return null;
      }
      return (
        <PhotoAlbum storyElement={firstPhotoAlbumElement} onSlideChange={this.handleSlideChange} pagetype="story" />
      );
    };

    return (
      <div className={`page-content`}>
        <div className={`container ${stylesPA["breadcrumb-holder"]}`}>
          <Breadcrumb story={this.props.story} config={this.props.config} />
        </div>
        <div className={`container ${styles["story-grid"]}`}>
          <div className={styles["main-content"]}>
            <article className={`${styles["story-body"]} js-story`}>
              {renderHeaderCard({ className: stylesPA["story-header"] })}
              {renderSocialMedia()}
              <p className={`${styles["subheadline"]}`}>{storyHeadline}</p>
              {renderHeaderPhotoAlbum()}
              {this.props.story.cards.map((card, index) => {
                const newCard = produce(card, draft => {
                  draft["story-elements"] = draft["story-elements"].filter(
                    element => element.id !== (firstPhotoAlbumElement && firstPhotoAlbumElement.id)
                  );
                });
                return (
                  <React.Fragment key={newCard.id}>
                    <VikatanResponsiveContainer
                      placement={"text-story"}
                      adtype={parseInt(index + 1)}
                      story={this.props.story}
                      className="ad_300_250"
                    />

                    {index === 1 && <StoryMidPromotion story={this.props.story} />}

                    <StoryCard key={newCard.id} card={newCard} story={this.props.story} />
                  </React.Fragment>
                );
              })}
              <div id="we-story-end" />

              {renderFooter()}
            </article>
          </div>
          {renderSidebar()}
        </div>
      </div>
    );
  }
}

const story = PropTypes.shape({
  id: PropTypes.string,
  authors: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
      slug: PropTypes.string,
      "avatar-url": PropTypes.string,
      "avatar-s3-key": PropTypes.string,
      "twitter-handle": PropTypes.string,
      bio: PropTypes.string
    })
  ),
  contributors: PropTypes.arrayOf(
    PropTypes.shape({
      "role-name": PropTypes.string,
      authors: PropTypes.arrayOf(
        PropTypes.shape({
          name: PropTypes.string
        })
      )
    })
  ),
  headline: PropTypes.string.isRequired,
  alternative: PropTypes.shape({
    home: PropTypes.shape({
      default: PropTypes.shape({
        headline: PropTypes.string
      })
    })
  }),
  slug: PropTypes.string.isRequired,
  "hero-image-metadata": PropTypes.shape({
    height: PropTypes.number,
    width: PropTypes.number,
    "aspect-ratio": PropTypes.arrayOf(PropTypes.number)
  }),
  "hero-image-s3-key": PropTypes.string,
  "hero-image-caption": PropTypes.string,
  cards: PropTypes.arrayOf(StoryCard.propTypes.card),
  "linked-stories": PropTypes.any
});

PhotoAlbumStory.propTypes = {
  story: story,
  config: Breadcrumb.propTypes.config,
  renderAuthorDetails: PropTypes.func,
  renderComments: PropTypes.func,
  renderReactions: PropTypes.func,
  renderSidebar: PropTypes.func,
  renderSocialMedia: PropTypes.func,
  renderTags: PropTypes.func,
  fireVirtualPageView: PropTypes.func
};
export { PhotoAlbumStory };
